// extracted by mini-css-extract-plugin
export var cardTitle = "_js-1";
export var commentBubble = "_js-e";
export var commentForm = "_js-a";
export var commentInput = "_js-b";
export var commentLabel = "_js-d";
export var commentPrompt = "_js-9";
export var csatCard = "_js-0";
export var feedbackSection = "_js-7";
export var starDisabled = "_js-6";
export var starEmpty = "_js-5";
export var starFilled = "_js-4";
export var starWrapper = "_js-3";
export var starsContainer = "_js-2";
export var submittedComment = "_js-c";
export var thankYouText = "_js-8";